<template>
  <transition name="PaB-active-filters">
    <div class="PaB-active-filters-wrapper" v-if="filters.length > 0">
      <div class="PaB-active-filters">
        <button class="PaB-clear-all" @click="resetFilters">
          <icon-base icon-name="dismiss" width="12" height="12">
            <icon-close />
          </icon-base> Clear All
        </button>
        <scroller ref="scroller">
          <div class="PaB-filter-chips">
            <transition-group name="PaB-chip-pop" tag="div" class="PaB-filter-chips-wrapper">
              <span class="PaB-filter-chip" v-for="filter in filters" :key="filter.label">
                <chip :dismissable="true" v-on:dismissed="removeFilter(filter.field, filter.value)">{{ filter.label }}</chip>
              </span>
            </transition-group>
          </div>
        </scroller>
      </div>
    </div>
  </transition>
</template>
<style lang="scss" scoped>
.PaB-clear-all {
  color: #fff;
  background-color: #000;
  border: 0;
  padding-right: 1em;
  flex: 0 0 auto;
  -webkit-appearance: none;
  height: 41px;
}
.PaB-active-filters-wrapper {
  position: relative;
  min-width: 100%;
}
.PaB-active-filters {
  display: flex;
  flex-direction: row;
  min-width: 100%;
  position: relative;
  overflow: hidden;
  max-height: 100%;
}
.PaB-scroller {
  background-color: #383838;
  flex: 1 1 auto;
}
.PaB-filter-chips {
  padding: 8px;
  position: relative;
  white-space: nowrap;
  width: 100%;

  .PaB-filter-chip {
    display: inline-block;
    margin: 0 2px;
    transition: transform 0.2s ease-in-out, opacity 0.2s linear;
  }
}

.PaB-chip-pop-leave-active {
  position: absolute;
}
.PaB-chip-pop-enter,
.PaB-chip-pop-leave-to {
  opacity: 0;
  transform: scale(0);
}

.PaB-active-filters-enter-active,
.PaB-active-filters-leave-active {
  transition: height 0.2s ease-in-out;
  height: 41px;
}
.PaB-active-filters-enter,
.PaB-active-filters-leave-to {
  height: 0;
}
</style>

<script>
import IconBase from '@/components/IconBase'
import IconClose from '@/components/icons/IconClose'
import Chip from '@/components/Chip'
import Scroller from '@/components/Scroller'

export default {
  components: {
    IconBase,
    IconClose,
    Chip,
    Scroller
  },
  data: function () {
    return {
      overflow: {
        left: false,
        right: false
      }
    }
  },
  computed: {
    filters () {
      return this.$store.getters['products/getActiveFilters']
    }
  },
  watch: {
    filters: function (val) {
      if (this.$refs.scroller) {
        this.$nextTick(this.$refs.scroller.checkOverflow)
      }
    }
  },

  methods: {
    removeFilter: function (filterSet, removeValue) {
      this.$store.dispatch('products/removeFilter', { key: filterSet, value: removeValue })
    },
    resetFilters: function () {
      this.$store.dispatch('products/resetFilters')
    }
  }
}
</script>
